<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape">
            <img
                src="img/fond/6.jpg"
                class="img-fluid"
            />
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center">
                        <img
                            src="img/brand/LogoAzterren.svg"
                            style="width: 60%;"
                            class="img-fluid logo mb-5"
                        />
                    </div>

                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4 mt-4 mt-sm-0 text-right"></div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {}
</script>
<style>
</style>
